import Cookies from "universal-cookie";
const cookies = new Cookies();

export const ajaxconfig = () => ({
    headers: {
        Authorization: `Bearer ${cookies.get("auth_key")}`, // Correct format
        email: cookies.get("email"),
        authenticated: cookies.get("authenticated"),
    }
});